import { CONTENT as DEFAULT_CONTENT } from '../abaBillingPlatform/constants';

/**
 * Content for /aba-billing-platform-2.
 *
 * Same layout, styles, artwork and animations as /aba-billing-platform — ONLY the copy differs.
 * Spread the shared `DEFAULT_CONTENT` and override whatever text you want; anything not overridden
 * falls back to the original page's copy. Every field can be overridden the same way:
 *   - hero:     { badgeA, badgeB, titleLead, titleAccent, subtitle, trust: [] }
 *   - features: array of 6 { eyebrow, title, body, bullets: [] }
 *   - rcm:      { eyebrow, title, body, bullets: [], cta }
 *   - finalCta: { badge, title, body, primary, secondary }
 *
 * The hero title renders as `titleLead` (white) + `titleAccent` (italic orange).
 */
export const CONTENT_V2 = {
    ...DEFAULT_CONTENT,
    hero: {
        ...DEFAULT_CONTENT.hero,
        titleLead: 'ABA billing software that catches mistakes ',
        titleAccent: 'before they cost you.',
    },

    // Example — override a feature section's copy (uncomment & edit):
    // features: DEFAULT_CONTENT.features.map((f, i) =>
    //     i === 0 ? { ...f, title: 'New heading', body: 'New body copy', bullets: ['One', 'Two'] } : f,
    // ),

    // Example — override the closing CTA (uncomment & edit):
    // finalCta: { ...DEFAULT_CONTENT.finalCta, title: 'New CTA headline' },
};
